export default function PHP_ftp_nb_continue() {
  return (
    <div>
      <h1>PHP_ftp_nb_continue</h1>
    </div>
  );
}
